var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagIt = function SvgIconFlagIt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.1,
    fill: "#D7D7D7",
    stroke: "#E7E7E7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B9246",
    d: "M4 12a7.99 7.99 0 0 0 3.429 6.561V5.44A7.99 7.99 0 0 0 4 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.571 5.44A7.96 7.96 0 0 0 12.001 4a7.96 7.96 0 0 0-4.574 1.44v13.12C8.725 19.466 10.3 20 12 20s3.275-.535 4.571-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D71F35",
    d: "M20 12a7.98 7.98 0 0 0-3.429-6.56v13.121A7.99 7.99 0 0 0 20 12"
  }))));
};
export { SvgIconFlagIt as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNFN0U3RTciLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4LjEiIGZpbGw9IiNEN0Q3RDciIHN0cm9rZT0iI0U3RTdFNyIgc3Ryb2tlLXdpZHRoPSIuMiIvPjxwYXRoIGZpbGw9IiMzQjkyNDYiIGQ9Ik00IDEyYTcuOTkgNy45OSAwIDAwMy40MjkgNi41NjFWNS40NEE3Ljk4NyA3Ljk4NyAwIDAwNCAxMiIvPjxwYXRoIGQ9Ik0xNi41NzEgNS40NEE3Ljk1NSA3Ljk1NSAwIDAwMTIuMDAxIDRhNy45NjMgNy45NjMgMCAwMC00LjU3NCAxLjQ0djEzLjEyQzguNzI1IDE5LjQ2NiAxMC4zIDIwIDEyIDIwczMuMjc1LS41MzUgNC41NzEtMS40NFY1LjQ0eiIgZmlsbD0iI0ZGRiIvPjxwYXRoIGZpbGw9IiNENzFGMzUiIGQ9Ik0yMCAxMmE3Ljk4NCA3Ljk4NCAwIDAwLTMuNDI5LTYuNTZ2MTMuMTIxQTcuOTg3IDcuOTg3IDAgMDAyMCAxMiIvPjwvZz48L3N2Zz4=";